module.exports = __webpack_public_path__ + "static/brown-concrete-roofs-1920x600-ecac000f183f6d19935234c5fad4b3d7.jpg";